<template>
  <div class="text-center">
    <loader-text
      title="auth.logout"
    />
  </div>
</template>

<script>
  import LoaderText from '@/components/loader-text';

  export default {
    name: 'LogoutView',
    components: {
      LoaderText,
    },
    computed: {
      route() {
        return this.get().route;
      },
    },
    created() {
      if (this.route.name === 'logout') {
        this.onClickLogout();
      }
    },
    methods: {
      onClickLogout() {
        this.$ajax.get('user/me/logout').finally(() => {
          this.unset(['oauth', 'code']);
          this.$router.push({ name: 'login' });
        });
      },
    },
  };
</script>


<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
